
import React, { useState } from "react";
import "./AdminPanel.css";

const AdminPanel = () => {
  const [sections, setSections] = useState(
    Array.from({ length: 10 }, () => ({ image: "", preview: "", heading: "", caption: "" }))
  );

  // Load existing data from localStorage on component mount
  React.useEffect(() => {
    const loadExistingData = () => {
      try {
        const storedData = JSON.parse(localStorage.getItem('sunlankaSections') || '[]');
        if (storedData.length > 0) {
          setSections(prevSections => 
            prevSections.map((section, index) => {
              const stored = storedData[index];
              if (stored && stored.image) {
                return {
                  ...section,
                  image: stored.image,
                  preview: stored.image,
                  heading: stored.heading || "",
                  caption: stored.caption || "",
                  uploaded: true
                };
              }
              return section;
            })
          );
        }
      } catch (err) {
        console.error("Error loading existing data:", err);
      }
    };

    loadExistingData();
  }, []);

  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      const updatedSections = [...sections];
      updatedSections[index] = {
        ...updatedSections[index],
        image: reader.result,
        preview: reader.result
      };
      setSections(updatedSections);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleInputChange = (e, index, field) => {
    const updatedSections = [...sections];
    updatedSections[index] = {
      ...updatedSections[index],
      [field]: e.target.value
    };
    setSections(updatedSections);
  };

  const handleUpload = async (index) => {
    const { image, heading, caption } = sections[index];
    if (!image) return alert("Please select an image.");

    try {
      // Store data in localStorage
      const storedData = JSON.parse(localStorage.getItem('sunlankaSections') || '[]');
      const newData = { 
        image, 
        heading, 
        caption,
        timestamp: new Date().toISOString()
      };
      
      console.log(`Storing data for section ${index}:`, {
        imageLength: image ? image.length : 0,
        imageStart: image ? image.substring(0, 50) + '...' : 'no image',
        heading,
        caption
      });
      
      storedData[index] = newData;
      localStorage.setItem('sunlankaSections', JSON.stringify(storedData));
      
      // Update local state
      const updatedSections = [...sections];
      updatedSections[index] = {
        ...updatedSections[index],
        uploaded: true
      };
      setSections(updatedSections);
      
      alert(`Section ${index + 1} uploaded successfully!`);
      console.log("Data saved to localStorage:", newData);
      
      // Trigger a custom event to notify newsfeed
      window.dispatchEvent(new CustomEvent('newsfeedUpdated', { 
        detail: { sections: storedData } 
      }));
      
    } catch (err) {
      console.error("Upload failed:", err);
      alert("Upload failed - check console for details");
    }
  };

  return (
    <div className="image-upload-sections">
      {sections.map((section, index) => (
        <div className="image-upload-section" key={index}>
          <h3>Section {index + 1}</h3>
          {section.preview && (
            <img src={section.preview} alt={`Preview ${index}`} />
          )}
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleImageChange(e, index)}
          />
          <input
            type="text"
            placeholder="Heading"
            value={section.heading}
            onChange={(e) => handleInputChange(e, index, "heading")}
          />
          <input
            type="text"
            placeholder="Caption"
            value={section.caption}
            onChange={(e) => handleInputChange(e, index, "caption")}
          />
          <button onClick={() => handleUpload(index)}>Upload</button>
        </div>
      ))}

    </div>
  );
};

export default AdminPanel;
